import { createSlice } from '@reduxjs/toolkit'

export const AllClientsSlice = createSlice({
  name: 'allClients',
  initialState: {
    value: [],
  },
  reducers: {
    updateClients: (state, action) => {
      state.value = action.payload;
    },
    removeClients: (state) => {
      state.value = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateClients, removeClients } = AllClientsSlice.actions

export const selectAllClients = state => state.allClients.value;

export default AllClientsSlice.reducer